<template>
  <div>
    <el-form :model="searchForm" inline>
      <el-form-item>
        <el-input v-model="searchForm.name" placeholder="名称" @keyup.enter.native="search" clearable>
          <el-button icon="el-icon-search" slot="append" @click="search"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="showCode">显示编码</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button v-if="$auth('function_add')" type="text" icon="el-icon-circle-plus-outline" @click="add({code:''})">新建功能</el-button>
      </el-form-item>
    </el-form>

    <el-tree ref="tree"
             node-key="code"
             :data="treeData"
             :props="props"
             :filter-node-method="filterNode"
             :expand-on-click-node="false"
             @check="checkChange"
             check-strictly
             show-checkbox>
       <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <span v-show="showCode" style="padding-right: 20px">
          {{ data.code }}
          </span>
          <span class="node-opt">
            <el-button type="text" @click.stop="edit(data)">
              修改
            </el-button>
            <el-button v-if="$auth('auth_add')" type="text" @click.stop="add(data)">
              添加
            </el-button>
          </span>
        </span>
       </span>
    </el-tree>

    <el-dialog :title="editTitle" :visible.sync="editVisible">
      <el-form label-width="120px" :model="editForm" :rules="editRules">
        <el-form-item label="父级" prop="pcode">
          {{ editForm.pcodeName }}【{{ editForm.pcode ? editForm.pcode:'root' }}】
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input type="text" maxlength="20" show-word-limit v-model="editForm.code" :readonly="editTitle==='修改'"></el-input>
        </el-form-item>
        <!--        <el-form-item label="显示顺序" prop="color">-->
        <!--          <el-input-number v-model="editForm.sort"></el-input-number>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-folder" @click="save(true)" :loading="editSaving">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {featureDelete, featureInsert, featureList, featureUpdate,} from "@/api/remote";
  import {buildTree, getTreeRoot} from "@/assets/utils";

  export default {
    name: "Features",
    data() {
      return {
        searching: false,
        searchForm: {
          name: null,
        },
        rows: [],
        props: {
          key: 'code',
          parentKey: 'pcode',
          label: 'name',
          children: 'children',
          rootValue: '',
          isLeaf: 'leaf'
        },
        showCode: true,
        editVisible: false,
        editSaving: false,
        editTitle: '新增',
        editItem: null,
        editForm: {
          code: null,
          name: null,
          pcode: null,
          sort: null,
        },
        editRules: {
          code: [
            {required: true, trigger: 'change', message: '请输入编码'}
          ],
          name: [
            {required: true, trigger: 'change', message: '请输入名称'}
          ],
        },
      }
    },
    computed: {
      treeRoot() {
        return getTreeRoot(this.rows, this.props)
      },
      treeData() {
        return buildTree(this.rows, this.props, this.treeRoot)
      }
    },
    methods: {
      getRows() {
        featureList().then(res => {
          this.rows = res.data
        });
      },
      add(parent) {
        this.editForm = {};
        this.editForm.pcode = parent.code;
        this.editForm.pcodeName = parent.name;
        this.editTitle = '新增';
        this.editVisible = true;
      },
      edit(data) {
        this.editItem = data;
        this.editForm = {...data};
        this.editTitle = '修改';
        this.editVisible = true;
      },
      remove(data, node) {
        this.$confirm(`确定删除${data.name}?`).then(() => {
          featureDelete({code: data.code}).then(res => {
            // 删除节点
            let tree = this.$refs.tree;
            tree.remove(data);
            this.$message.success('删除成功');
          })
        });
      },
      save() {
        if (this.editTitle === '修改') {
          this.editSaving = true;
          featureUpdate(this.editForm).then(res => {
            this.$message.success('修改成功');
            for (let key in this.editForm) {
              this.editItem[key] = this.editForm[key];
            }
            this.editSaving = false;
            this.editVisible = false;
          }, () => this.editSaving = false)
        } else {
          this.editSaving = true;
          featureInsert(this.editForm).then(res => {
            // 添加节点
            let tree = this.$refs.tree;
            if (!this.editForm.pcode) {
              tree.root.doCreateChildren([this.editForm])
            } else {
              tree.append(this.editForm, this.editForm.pcode);
            }
            this.$message.success('创建成功');
            this.editSaving = false;
            this.editVisible = false;
          }, () => this.editSaving = false)
        }
      },
      checkChange(data, checked) {
        this.$emit('check', data, checked);
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      search() {
        this.$refs.tree.filter(this.searchForm.name);
      },
      setCheckedKeys(keys, leafOnly) {
        this.$refs.tree.setCheckedKeys(keys, leafOnly);
      }
    },
    created() {
      this.getRows();
    }
  }
</script>

<style scoped>

</style>
